import { getActivePaymentSession } from "@/lib/paymentSession";

export function normalizeActivePaymentSession(response) {
  const root = response?.data || response || {};
  const hasActiveSession = Boolean(
    root?.has_active_session ?? root?.hasActiveSession ?? root?.session,
  );
  if (!hasActiveSession) {
    return null;
  }

  const session = root?.session || root?.paymentSession || {};
  const paymentSessionId =
    session?.payment_session_id || session?.paymentSessionId || session?.id || null;
  if (!paymentSessionId) {
    return null;
  }

  return {
    paymentSessionId,
    orderId:
      session?.lock_owner_order_id ||
      session?.lockOwnerOrderId ||
      session?.order_id ||
      session?.orderId ||
      null,
    orderCode:
      session?.lock_owner_order_code ||
      session?.lockOwnerOrderCode ||
      session?.order_code ||
      session?.orderCode ||
      null,
    lockOwnerOrderId:
      session?.lock_owner_order_id || session?.lockOwnerOrderId || null,
    lockOwnerOrderCode:
      session?.lock_owner_order_code || session?.lockOwnerOrderCode || null,
    status: String(session?.status || "ACTIVE").toUpperCase(),
    expiresAt: session?.expires_at || session?.expiresAt || null,
  };
}

export async function getActivePaymentSessionSnapshot() {
  const response = await getActivePaymentSession();
  return normalizeActivePaymentSession(response);
}

